<!--
  << 이슈들 >>
  MARK_001
    : vs-radio이 여러그룹이 존재할 경우 그룹간의 vs-value의 값을 동일하게 하면,
      클릭표기가 보이지 않는 UI버그가 있다. (v-model은 변경되어 있으나, ui상에서만 문제가 있음)
-->

<template>
  <div>

    <vx-card>

      <div class="vx-row">
        <!-- ID / 이름 -->
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row mb-4">

            <!-- ID : 등록 외에는 수정불가능 -->
            <div class="vx-col sm:w-full w-full">
              <div v-if="formMode === 'register'" class="vx-row mb-4" >
                <h5 class="flex vx-col sm:w-3/12" style="align-items: center">ID</h5>
                <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="아이디" v-model="member.username"/>
              </div>
              <div v-else class="vx-row mb-4">
                <h5 class="flex vx-col sm:w-3/12" style="align-items: center">ID</h5>
                <vs-input class="vx-col sm:w-8/12 w-full mb-2" readonly placeholder="아이디" v-model="member.username"/>
              </div>
            </div>

            <!-- 이름 -->
            <div class="vx-col sm:w-full w-full">
              <div class="vx-row">
                <h5 class="flex vx-col sm:w-3/12" style="align-items: center">이름</h5>
                <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="이름" v-model="member.name"/>
              </div>
            </div>
          </div>
        </div>

        <!-- 비밀번호 / 비밀번호확인 -->
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row mb-4">

            <!-- 비밀번호 -->
            <div class="vx-col sm:w-full w-full">
              <div class="vx-row mb-4">
                <h5 class="flex vx-col sm:w-3/12" style="align-items: center">비밀번호</h5>
                <vs-input class="vx-col sm:w-8/12 w-full mb-2"
                          type="password"
                          placeholder="비밀번호"
                          v-model="password"
                          tabindex="1" />
              </div>
            </div>

            <!-- 비밀번호 확인 -->
            <div class="vx-col sm:w-full w-full">
              <div class="vx-row">
                <h5 class="flex vx-col sm:w-3/12" style="align-items: center">비밀번호 확인</h5>
                <vs-input class="vx-col sm:w-8/12 w-full mb-2"
                          type="password"
                          placeholder="비밀번호 확인"
                          v-model="repassword"
                          tabindex="2"/>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- 닉네임 / 이메일 -->
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-6/12 w-full">

          <!-- 닉네임 -->
          <div class="vx-row">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center">닉네임</h5>
            <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="닉네임" v-model="member.nickname"/>
          </div>
        </div>

        <!-- 이메일 -->
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center">이메일</h5>
            <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="이메일" v-model="member.email"/>
          </div>
        </div>
      </div>

      <!-- 생년월일 -->
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center">생년월일</h5>
            <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="생년월일" v-model="member.birthdate"/>

          </div>
        </div>
      </div>

      <!-- 휴대폰번호 -->
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center">휴대폰번호</h5>
            <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="휴대폰번호" v-model="member.mobile"/>
          </div>
        </div>
      </div>

      <!-- 전화번호 -->
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center">전화번호</h5>
            <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="전화번호" v-model="member.phone"/>
          </div>
        </div>
      </div>

      <!-- 자택주소 -->
      <div class="vx-row">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center">자택주소</h5>
            <vs-input class="vx-col sm:w-4/12 w-full mb-2" readonly placeholder="우편번호" v-model="member.home_zip"/>
            <vs-button class="mb-5" color="primary" type="border" @click="homePostcode.active = true">우편번호</vs-button>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center"></h5>
            <vs-input class="vx-col sm:w-8/12 w-full mb-2" readonly placeholder="자택주소" v-model="member.home_address_1"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center"></h5>
            <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="상세주소입력" v-model="member.home_address_2"/>
          </div>
        </div>
      </div>

      <!-- 근무처주소 -->
      <div class="vx-row">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center">근무처주소</h5>
            <vs-input class="vx-col sm:w-4/12 w-full mb-2" readonly placeholder="우편번호" v-model="member.company_zip"/>
            <vs-button class="mb-5" color="primary" type="border" @click="companyPostcode.active = true">우편번호</vs-button>

          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center"></h5>
            <vs-input class="vx-col sm:w-8/12 w-full mb-2" readonly placeholder="근무처주소" v-model="member.company_address_1"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center"></h5>
            <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="상세주소입력" v-model="member.company_address_2"/>
          </div>
        </div>
      </div>

      <!-- 자택주소 -->
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row h-12">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center">자택주소</h5>
            <div class="vx-col sm:w-8/12 mt-4">
              <ul class="vx-row">
                <li class="vx-col w-1/4">
                  <vs-radio v-model="subscribe_email" vs-value="email_1">수신함</vs-radio>
                </li>
                <li class="vx-col w-1/4">
                  <vs-radio v-model="subscribe_email" vs-value="email_0">수신안함</vs-radio>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- SMS 수신여부 -->
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row  h-12">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center">SMS 수신여부</h5>
            <div class="vx-col sm:w-8/12  mt-4">
              <ul class="vx-row">
                <li class="vx-col w-1/4">
                  <vs-radio v-model="subscribe_sms" vs-value="sms_1">수신함</vs-radio>
                </li>
                <li class="vx-col w-1/4">
                  <vs-radio v-model="subscribe_sms" vs-value="sms_0">수신안함</vs-radio>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- 우편물 수령지 -->
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row h-12">
            <h5 class="flex vx-col sm:w-3/12" style="align-items: center">우편물 수령지</h5>
            <div class="vx-col sm:w-8/12  mt-4">
              <ul class="vx-row">
                <li class="vx-col w-1/4">
                  <vs-radio v-model="member.mail_destination" vs-value="home">자택</vs-radio>
                </li>
                <li class="vx-col w-1/4">
                  <vs-radio v-model="member.mail_destination" vs-value="company">근무지</vs-radio>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- 프로필 이미지 첨부 -->
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-6/12 w-full">
          <div class="vx-row align-item">
            <h5 class="vx-col sm:w-3/12 mt-4">프로필 이미지 첨부</h5>
            <div id="profileUpload" class="vx-col sm:w-6/12">
              <vs-upload
                ref="vs_upload"
                file-name="file_data"
                :action="`${baseAPIUrl}/api/v1/file`"
                :headers="headerToken"
                :multiple="false"
                :show-upload-button="false"
                limit="1"
                automatic
                @on-success="successUploadProfile"
                @on-delete="deleteUploadProfile"
                @change="changeFilesProfile"></vs-upload>
                <!-- accept : 첨부가능한 파일 확장자 -->
            </div>
          </div>
        </div>
      </div>

      <vs-row class="w-full mt-8" vs-justify="center">
        <vs-button class="sm:w-2/12 mr-4 large" color="secondary" @click="handleClickSave">저장</vs-button>
        <vs-button class="sm:w-2/12 large" color="#EDEDED" text-color="black" type="filled" @click="handleClickCancel">취소</vs-button>
      </vs-row>

    </vx-card>

    <!-- 다음우편번호 -->
    <vs-popup :title="homePostcode.title" :active.sync="homePostcode.active">
      <vue-daum-postcode @complete="handlePostcodeComplete"/>
    </vs-popup>
    <vs-popup :title="companyPostcode.title" :active.sync="companyPostcode.active">
      <vue-daum-postcode @complete="handlePostcodeComplete"/>
    </vs-popup>

  </div>
</template>

<script>
import config from '/public/config'
import VueCookie from 'vue-cookie'
import { VueDaumPostcode } from 'vue-daum-postcode'
import memberModule from '@/store/member/memberModule.js'

const MODE_MODIFY = 'modify'
const MODULE_MEMBER = 'member'
export default {
  components: {
    VueDaumPostcode
  },
  data () {
    return {
      baseAPIUrl: config.BASE_API_URL,
      popupActivo:false,
      formMode:MODE_MODIFY,
      member:{mail_destination:'', subscribe_email:0, subscribe_sms:0, avatar:{id:0} },
      password:'',
      repassword:'',

      homePostcode:{
        active:false,
        title:'우편번호 검색'
      },
      companyPostcode:{
        active:false,
        title:'우편번호 검색'
      },

      // 프로필 이미지
      file: null, // vs-upload files
      headerToken:{},

      // 이슈(MARK_001)을 해결하기위한 추가 변수
      subscribe_email:'',
      subscribe_sms:''
    }
  },

  mounted () {
    const userId = VueCookie.get(this.$store.state.member.COOKIE_KEY_CURRENT_USER_ID)

    // file upload 시  xmlrequest에서 헤더를 붙이기 위함
    this.headerToken = {
      Authorization: `Bearer ${  VueCookie.get('token')}`
    }

    // 유저ID가 없을 경우 등록하기 모드를 사용한다.
    // 새로 등록하지 않고, 뒤로 가려면
    // this.$router.go(-1); 을 사용하면 된다.
    if (!userId) {
      this.formMode = 'register'
      this.subscribe_email = 'email_0'
      this.subscribe_sms = 'sms_0'

      this.member.subscribe_email = 0
      this.member.subscribe_sms = 0
      this.member.mail_destination = 'home'
      return
    }

    // 회원정보 불러오기
    this.loadMember(userId)


  },

  created () {

    // 동적 모듈 등록
    if (!this.$store.hasModule(MODULE_MEMBER)) {
      this.$store.registerModule(MODULE_MEMBER, memberModule)
    }


  },

  methods: {

    // 이슈(MARK_001)를 해결하기 위해 추가한 prefix를 삭제한다.
    removeFlagPrefix (value) {
      if (!value) {
        return '0'
      }

      const strArray = value.split('_')
      if (strArray.length === 2) {
        return strArray[1]
      } else {
        return '0'
      }
    },

    // 회원정보 불러오기
    async loadMember (userId) {
      await this.$store.dispatch('member/LOAD_MEMBER', {userId})

      // 수정된 부분을 체크하기위해 깊은복사를 한다.
      this.member = Object.assign({}, this.$store.state.member.memberInfo)

      // 이슈(MARK_001)을 해결하기 위해 value에 prefix를 추가한다.
      this.subscribe_email = (this.member.subscribe_email) ? 'email_1' : 'email_0'
      this.subscribe_sms = (this.member.subscribe_sms) ? 'sms_1' : 'sms_0'

      // 프로필 이미지 존재시, vs-upload에 이미지를 넣어준다.
      if (this.member.avatar) {
        this.setVsUploadImage(this, this.member.avatar.path)
      }
    },


    async registerMember () {
      const param = {
      }

      if (!this.member.username || this.member.username.length <= 0) {
        alert('ID를 입력하세요. ID는 로그인에 사용됩니다.')
        return
      }

      if (!this.member.email || this.member.email.length <= 0) {
        alert('Email를 입력하세요. Email는 비밀번호를 찾을때 사용됩니다.')
        return
      }

      // 비밀번호 변경
      let updatePassword = false
      if (this.password.length < 8 || this.password.length > 255) {
        alert('비밀번호는 8~255자리까지 입력 가능합니다.')
        return
      }

      if (this.password !== this.repassword) {
        alert('올바른 비밀번호를 입력하세요.')
        return
      }

      // 그외 비밀번호 제약조건
      // ...

      //비밀번호를 변경하도록 수락한다.
      updatePassword = true

      // 변경된 내용만 수정요청 한다.
      let changeCount = 0
      const oldMember = this.$store.state.member.memberInfo
      if (this.member.username !== oldMember.username) { param.username = this.member.username; changeCount++ }
      if (this.member.email !== oldMember.email) { param.email = this.member.email; changeCount++ }

      if (this.member.name !== oldMember.name) { param.name = this.member.name; changeCount++ }
      if (this.member.nickname !== oldMember.nickname) { param.nickname = this.member.nickname; changeCount++ }
      if (this.member.birthdate !== oldMember.birthdate) { param.birthdate = this.member.birthdate; changeCount++ }
      if (this.member.mobile !== oldMember.mobile) { param.mobile = this.member.mobile; changeCount++ }
      if (this.member.phone !== oldMember.phone) { param.phone = this.member.phone; changeCount++ }
      if (this.member.home_zip !== oldMember.home_zip) { param.home_zip = this.member.home_zip; changeCount++ }
      if (this.member.home_address_1 !== oldMember.home_address_1) { param.home_address_1 = this.member.home_address_1; changeCount++ }
      if (this.member.home_address_2 !== oldMember.home_address_2) { param.home_address_2 = this.member.home_address_2; changeCount++ }
      if (this.member.company_zip !== oldMember.company_zip) { param.company_zip = this.member.company_zip; changeCount++ }
      if (this.member.company_address_1 !== oldMember.company_address_1) { param.company_address_1 = this.member.company_address_1; changeCount++ }
      if (this.member.company_address_2 !== oldMember.company_address_2) { param.company_address_2 = this.member.company_address_2; changeCount++ }
      if (this.member.subscribe_email !== oldMember.subscribe_email) { param.subscribe_email = this.member.subscribe_email; changeCount++ }
      if (this.member.subscribe_sms !== oldMember.subscribe_sms) { param.subscribe_sms = this.member.subscribe_sms; changeCount++ }
      if (this.member.mail_destination !== oldMember.mail_destination) { param.mail_destination = this.member.mail_destination; changeCount++ }
      if (this.member.avatar) {
        param.avatar = this.member.avatar.id
      }

      if (this.subscribe_email !== `email_${oldMember.subscribe_email}`) { param.subscribe_email = this.removeFlagPrefix(this.subscribe_email); changeCount++ }
      if (this.subscribe_sms !== `sms_${oldMember.subscribe_sms}`) { param.subscribe_sms = this.removeFlagPrefix(this.subscribe_sms); changeCount++ }
      if (updatePassword) {
        param.password = this.password
        param.password_confirmation = this.repassword
        changeCount++
      }

      if (changeCount > 0) {
        await this.$store.dispatch('member/REGISTER_MEMBER', param)
          .then((/*response*/) => {
            // success
            alert('회원정보가 저장되었습니다.')
            // 저장 이후 데이터 싱크를 위해서 리로드
            document.location.reload()
          })
          .catch((/*err*/) => {
            // fail
            alert('저장에 실패하였습니다. 관리자에게 문의 바랍니다.')
          })

      } else {
        alert('변경된 값이 없습니다.')
      }
    },

    async modifyMember () {
      const param = {
        userId:this.member.id
      }


      // 비밀번호 변경
      let updatePassword = false
      if (this.password) {

        if (this.password.length < 8 || this.password.length > 255) {
          alert('비밀번호는 8~255자리까지 입력 가능합니다.')
          return
        }

        if (this.password !== this.repassword) {
          alert('올바른 비밀번호를 입력하세요.')
          return
        }

        // 그외 비밀번호 제약조건
        // ...

        //비밀번호를 변경하도록 수락한다.
        updatePassword = true
      }

      // 변경된 내용만 수정요청 한다.
      let changeCount = 0
      const oldMember = this.$store.state.member.memberInfo
      if (this.member.name !== oldMember.name) { param.name = this.member.name; changeCount++ }
      if (this.member.nickname !== oldMember.nickname) { param.nickname = this.member.nickname; changeCount++ }
      if (this.member.birthdate !== oldMember.birthdate) { param.birthdate = this.member.birthdate; changeCount++ }
      if (this.member.mobile !== oldMember.mobile) { param.mobile = this.member.mobile; changeCount++ }
      if (this.member.phone !== oldMember.phone) { param.phone = this.member.phone; changeCount++ }
      if (this.member.home_zip !== oldMember.home_zip) { param.home_zip = this.member.home_zip; changeCount++ }
      if (this.member.home_address_1 !== oldMember.home_address_1) { param.home_address_1 = this.member.home_address_1; changeCount++ }
      if (this.member.home_address_2 !== oldMember.home_address_2) { param.home_address_2 = this.member.home_address_2; changeCount++ }
      if (this.member.company_zip !== oldMember.company_zip) { param.company_zip = this.member.company_zip; changeCount++ }
      if (this.member.company_address_1 !== oldMember.company_address_1) { param.company_address_1 = this.member.company_address_1; changeCount++ }
      if (this.member.company_address_2 !== oldMember.company_address_2) { param.company_address_2 = this.member.company_address_2; changeCount++ }
      if (this.member.subscribe_email !== oldMember.subscribe_email) { param.subscribe_email = this.member.subscribe_email; changeCount++ }
      if (this.member.subscribe_sms !== oldMember.subscribe_sms) { param.subscribe_sms = this.member.subscribe_sms; changeCount++ }
      if (this.member.mail_destination !== oldMember.mail_destination) { param.mail_destination = this.member.mail_destination; changeCount++ }
      if (this.member.avatar) {
        if (this.member.avatar.id !== oldMember.avatar.id) { param.avatar = this.member.avatar.id; changeCount++ }
      }

      if (this.subscribe_email !== `email_${oldMember.subscribe_email}`) { param.subscribe_email = this.removeFlagPrefix(this.subscribe_email); changeCount++ }
      if (this.subscribe_sms !== `sms_${oldMember.subscribe_sms}`) { param.subscribe_sms = this.removeFlagPrefix(this.subscribe_sms); changeCount++ }
      if (updatePassword) {
        param.password = this.password
        param.password_confirmation = this.repassword
        changeCount++
      }

      if (changeCount > 0) {
        await this.$store.dispatch('member/MODIFY_MEMBER', param)
          .then((/*response*/) => {
            // success
            alert('회원정보가 저장되었습니다.')

            // 저장 이후 데이터 싱크를 위해서 리로드
            document.location.reload()
          })
          .catch((/*err*/) => {
            // fail
            alert('저장에 실패하였습니다. 관리자에게 문의 바랍니다.')
          })

      } else {
        alert('변경된 값이 없습니다.')
      }
    },

    //===== [ 프로필 이미지 ] =====

    // file upload 완료시 이빈트
    successUploadProfile (event) {
      // response
      const response = JSON.parse(event.currentTarget.response)

      this.member.avatar.id = response.id
    },

    deleteUploadProfile () {
      this.changeFilesProfile('', this.$refs.vs_upload.filesx)
    },

    // upload시 파일
    changeFilesProfile (path, file) {
      this.file = file
    },

    // vs-upload에 초기 이미지 넣기
    setVsUploadImage (_t, src) {
      let orientation = 'h'
      const image = new Image()
      image.src = src
      image.onload = function () {
        if (this.width > this.height) {
          orientation = 'w'
        }
        _t.$refs.vs_upload.srcs.push({
          src:this.src,
          orientation,
          type:'image',
          percent:null,
          error:false,
          remove:false
        })
      }
    },

    //===== [ dev ] =====

    is_number (v) {
      const reg = /^(\s|\d)+$/
      return reg.test(v)
    },


    //===== [ handle ] ======

    handleClickSave () {
      if (this.formMode === 'register') {
        this.registerMember()
      } else if (this.formMode === MODE_MODIFY) {
        this.modifyMember()
      } else {
        alert('정보저장에 문제가 있습니다.')
      }
    },

    handleClickCancel () {
      this.$router.go(-1)
    },

    handlePostcodeComplete (data) {

      // 도로명(R), 지번(J)
      const userSelectedType = data.userSelectedType

      // 우편번호
      const zonecode = data.zonecode

      // 주소
      let address1 = data.roadAddress
      if (userSelectedType === 'J') {
        address1 = data.jibunAddress
      }


      // 자택주소
      if (this.homePostcode.active) {
        this.member.home_zip = zonecode
        this.member.home_address_1 = address1
      } else if (this.companyPostcode.active) {
        this.member.company_zip = zonecode
        this.member.company_address_1 = address1
      }


      this.homePostcode.active = false
      this.companyPostcode.active = false
    }

  }//methods
}
</script>

<style>
  /* scoped 에서는 vue-daum-postcode 높이조정이 되지 않아 별도로 작성했습니다.*/
  .vue-daum-postcode{
    height:444px;
  }
  .vue-daum-postcode-container{
    height:444px !important;
  }
</style>


<style>
#profileUpload{
  padding-left:0;
}
#profileUpload .con-upload .con-img-upload{
  padding:0;
}


</style>
